<template lang="pug">
  v-row(align="center" justify="center")
    v-col(cols="6")
      v-card
        v-card-title
          | Cities List
          v-spacer
          v-text-field.mt-n5(v-model='search' append-icon='mdi-magnify' label='Search' single-line hide-details fixed-header @keyup.enter="fetchCities()" clearable)
          v-spacer
          v-tooltip(bottom)
            template(v-slot:activator="{ on }")
              v-btn(icon)
                v-icon(@click="dialog = true" v-on="on") mdi-map-plus
            span Add City
        v-data-table(:headers='headers' :items='cities' :options.sync="options" :server-items-length="totalCities" sort-by="name")
          template(v-slot:item.country_code='{ item }') {{ item.country_code | getCountryName }}
          template(v-slot:item.action='{ item }')
            v-btn(icon)
              v-icon(small @click="editItem(item)") mdi-pencil
            v-btn(icon)
              v-icon(small @click="deleteItem(item.id)") mdi-delete
        v-dialog(v-model='dialog' persistent max-width='600px')
          v-card
            v-card-title
              span.headline {{ editCity ? 'Edit City' : 'Add City' }}
            v-card-text
              v-container
                v-row
                  v-col(cols="12")
                    v-text-field(v-model="newCity" label="City Name")
                  v-col(cols="12")
                    v-autocomplete(v-model="newCountry" :items="country" item-text="name" item-value="code" label='Country')
            v-card-actions
              v-spacer
              v-btn(color="red darken-3" text @click="closeDialog") Close
              v-btn(color="success" text @click='saveCountry') Save
</template>

<script>
export default {
  name: 'Cities',
  data: () => ({
    search: '',
    dialog: false,
    headers: [
      { text: 'City', value: 'name' },
      { text: 'Country', value: 'country_code' },
      { text: 'Action', value: 'action', sortable: false }
    ],
    cities: [],
    newCity: '',
    newCountry: '',
    editCity: null,
    country: [],
    options: {},
    totalCities: 0
  }),
  watch: {
    options: {
      handler () {
        // console.log(this.options)
        this.fetchCities(this.options.page, this.options.itemsPerPage)
      },
      deep: true
    }
  },
  mounted () {
    this.fetchCities()
    this.fetchCountry()
  },
  methods: {
    fetchCities (page = 1, itemsPerPage = 10) {
      this.axios.get(`/cities/?ordering=name&page=${page}&page_size=${itemsPerPage}&search=${this.search}`)
        .then(resp => {
          this.cities = [...resp.data.results]
          this.totalCities = resp.data.count
        })
    },
    fetchCountry () {
      const countryList = require('country-list')
      this.country = countryList.getData()
      // console.log(this.country)
    },
    saveCountry () {
      if (this.newCity && this.newCountry && !this.editCity) {
        this.$axios.post('/cities/',{ name: this.newCity, country_code: this.newCountry })
          .then(resp => {
            if (resp.data.id) {
              this.dialog = false
              this.newCity = ''
              this.newCountry = ''
              this.$alert.success('Add Country Successful!')
              this.fetchCities()
            }
          })
      } else if (this.newCity && this.newCountry && this.editCity) {
        this.$axios.patch(`/cities/${this.editCity}/`,{ name: this.newCity, country_code: this.newCountry })
          .then(resp => {
            if (resp.data.id) {
              this.dialog = false
              this.editCity = null
              this.$alert.success('Edit Country Successful!')
              this.fetchCities()
            }
          })
      } else {
        this.dialog = false
        this.editCity = null
      }
    },
    editItem (item) {
        this.dialog = true
        this.newCity = item.name
        this.newCountry = item.country_code
        this.editCity = item.id
    },
    deleteItem (item) {
      confirm('Are you sure you want to remove this city?') &&
      this.$axios.delete(`/cities/${item}/`)
       .then(resp => {
         this.$showAlert('grey darken-2','Remove City Successful!')
         this.fetchCities()
       })
    },
    closeDialog () {
      this.dialog = false
      this.editCity = null
      this.newCity = ''
      this.newCountry = ''
    }
  }
}
</script>

<style lang="scss" scoped>

</style>